import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin } from "lucide-react";

export const Footer = () => {
	return (
		<footer
			className="bg-black text-white border-t-4 border-black"
			data-testid="footer"
		>
			{/* Marquee */}
			<div className="py-4 bg-accent-yellow text-black border-b-4 border-black marquee">
				<div className="marquee-track">
					<div className="marquee-group">
						<span className="font-heading text-2xl mx-8">RIKAMI</span>
						<span className="font-body text-lg mx-8">
							{" "}
							ABBIGLIAMENTO RICAMATO{" "}
						</span>
						<span className="font-heading text-2xl mx-8">RIKAMI</span>
						<span className="font-body text-lg mx-8"> URBAN STYLE </span>
						<span className="font-heading text-2xl mx-8">RIKAMI</span>
						<span className="font-body text-lg mx-8"> MADE WITH LOVE </span>
						<span className="font-heading text-2xl mx-8">RIKAMI</span>
						<span className="font-body text-lg mx-8">
							{" "}
							ABBIGLIAMENTO RICAMATO{" "}
						</span>
					</div>
					<div className="marquee-group" aria-hidden="true">
						<span className="font-heading text-2xl mx-8">RIKAMI</span>
						<span className="font-body text-lg mx-8">
							{" "}
							ABBIGLIAMENTO RICAMATO{" "}
						</span>
						<span className="font-heading text-2xl mx-8">RIKAMI</span>
						<span className="font-body text-lg mx-8"> URBAN STYLE </span>
						<span className="font-heading text-2xl mx-8">RIKAMI</span>
						<span className="font-body text-lg mx-8"> MADE WITH LOVE </span>
						<span className="font-heading text-2xl mx-8">RIKAMI</span>
						<span className="font-body text-lg mx-8">
							{" "}
							ABBIGLIAMENTO RICAMATO{" "}
						</span>
					</div>
				</div>
			</div>

			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
				<div className="grid grid-cols-1 md:grid-cols-4 gap-12">
					{/* Brand */}
					<div className="md:col-span-2">
						<h2 className="font-heading text-5xl mb-4">RIKAMI</h2>
						<p className="font-body text-gray-400 mb-6 max-w-md">
							Abbigliamento ricamato per chi osa essere diverso. Ogni pezzo è
							unico, come te.
						</p>
						<div className="flex space-x-4">
							<a
								href="https://instagram.com/rikamibrand"
								target="_blank"
								rel="noopener noreferrer"
								className="p-3 border-2 border-white hover:bg-accent-pink hover:border-accent-pink"
								data-testid="instagram-link"
							>
								<Instagram size={24} />
							</a>
							<a
								href="mailto:info@rikami.it"
								className="p-3 border-2 border-white hover:bg-accent-blue hover:border-accent-blue"
								data-testid="email-link"
							>
								<Mail size={24} />
							</a>
						</div>
					</div>

					{/* Shop */}
					<div>
						<h3 className="font-heading text-xl mb-6">SHOP</h3>
						<ul className="space-y-3 font-body">
							<li>
								<Link to="/abbigliamento" className="hover:text-accent-pink">
									Abbigliamento
								</Link>
							</li>
							<li>
								<Link to="/magliette" className="hover:text-accent-pink">
									Magliette
								</Link>
							</li>
							<li>
								<Link to="/felpe" className="hover:text-accent-pink">
									Felpe
								</Link>
							</li>
							<li>
								<Link to="/" className="hover:text-accent-pink">
									Collezione Astro
								</Link>
							</li>
							<li>
								<Link to="/" className="hover:text-accent-pink">
									Collezione Drinks
								</Link>
							</li>
							<li>
								<Link to="/" className="hover:text-accent-pink">
									Collezione Quotes
								</Link>
							</li>
						</ul>
					</div>

					{/* Info */}
					<div>
						<h3 className="font-heading text-xl mb-6">INFO</h3>
						<ul className="space-y-3 font-body">
							<li>
								<Link to="/chi-siamo" className="hover:text-accent-blue">
									Chi Siamo
								</Link>
							</li>
							<li>
								<Link to="/contatti" className="hover:text-accent-blue">
									Contatti
								</Link>
							</li>
							<li>
								<a href="#" className="hover:text-accent-blue">
									Spedizioni
								</a>
							</li>
							<li>
								<a href="#" className="hover:text-accent-blue">
									Resi
								</a>
							</li>
						</ul>
					</div>
				</div>

				{/* Bottom */}
				<div className="mt-16 pt-8 border-t-2 border-gray-800 flex flex-col md:flex-row justify-between items-center">
					<p className="font-mono text-sm text-gray-500">
						© 2024 RIKAMI. Tutti i diritti riservati.
					</p>
					<div className="flex items-center mt-4 md:mt-0 font-mono text-sm text-gray-500">
						<MapPin size={16} className="mr-2" />
						Made in Italia
					</div>
				</div>
			</div>
		</footer>
	);
};
